angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListComunicateIcsController',
	function(
		$rootScope, $scope, $state, $stateParams, $timeout,
		$confirm,
		InvitationListComunicateService
	) {

	$scope.id              = $stateParams.id;
	$scope.event_id        = $stateParams.event_id;

	$scope.tinymceOptionsReady = false;

	$scope.tinymceOptionsEmailSubjectDem = angular.copy($rootScope.tinymceOptionsEmailSubject);
	$scope.tinymceOptionsEmailBodyDem = angular.copy($rootScope.tinymceOptionsEmailBody);

	$rootScope.getInvitationList($stateParams.id);

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventTags( $stateParams.event_id );

	$scope.$on( 'event_tag_loaded', function() {

		var tinymceValues = [
			{ text: 'Nome', value: '{FIRST_NAME}' },
			{ text: 'Cognome', value: '{LAST_NAME}' },
			{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
			{ text: 'Data Tappa A', value: '{FIRST_STAGE_DAY_TO}' },
			{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
			{ text: 'Orario Tappa A', value: '{FIRST_STAGE_TIME_TO}' },
			{ text: 'Nome Location', value: '{LOCATION_NAME}' },
			{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
			{ text: 'Nome Agenzia', value: '{AGENCY_NAME}' },
		];

		angular.forEach($rootScope.eventTagData, function(tag, key) {
			if ( tag.type === 'text' ) {
				var value = tag.tag.toLowerCase();
				value = value.replace(' ', '_');
				value = value.replace('à', 'a');
				value = value.replace('è', 'e');
				value = value.replace('é', 'e');
				value = value.replace('ì', 'i');
				value = value.replace('ò', 'o');
				value = value.replace('ù', 'u');
				value = value.replace(/[^a-zA-Z0-9]/g,'_');
				value = value.toUpperCase();
				tinymceValues.push( { text: tag.tag, value: '{' + value + '}' } )
			}
		});

		$scope.tinymceOptionsEmailSubjectDem.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};

		$scope.tinymceOptionsEmailBodyDem.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};


		$scope.tinymceOptionsReady = true;

	});

	$scope.checkIcsForm = function() {
		if ( !$scope.forms.ics_form.$invalid &&
			 $rootScope.invitationListData ) {
			return false;
		}
		return true;
	};

	$scope.saveIcs = function()
	{
		var invitationListData = angular.copy($rootScope.invitationListData);

		InvitationListComunicateService
			.updateIcs(invitationListData)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					$rootScope.invitationListData = data;

					$scope.showSuccessMsg('File Calendario aggiornato con successo!', '');
				}

			});
	};

});
